export class CookieService {
    static setCookie(name: string, val: string, numDays: number, domain?: string, secure?: boolean): void {
        const date = new Date();
        date.setTime(date.getTime() + (numDays * 24 * 60 * 60 * 1000));

        let cookieValue = `${name}=${val}; expires=${date.toUTCString()}; path=/`;

        if (domain) {
            cookieValue += `; domain=${domain}`;
        }

        if (secure) {
            cookieValue += '; Secure;';
        }

        document.cookie = cookieValue;
    }

    static getCookie(name: string): string {
        const value = '; ' + document.cookie;
        const parts = value.split('; ' + name + '=');

        if (parts.length === 2) {
            return parts.pop().split(';').shift();
        }
    }

    static deleteCookie(name: string): void {
        const date = new Date();
        // Set it expire in -1 days
        date.setTime(date.getTime() + (-1 * 24 * 60 * 60 * 1000));
        document.cookie = `${name}=; expires=${date.toUTCString()}; path=/`;
    }
}
